'use client'

import Overview from './Overview'
import { Icon } from '@/icons/Icon'
import { cn, formatUpdatedDate } from '@/lib/utils'

type TimestampProps = TimestampRowProps & {
  modified?: string
  published?: string
  className?: string
}

type TimestampRowProps = {
  date?: string
  lead?: string
  trail?: string
}

export default function Timestamp({ modified, published, lead, trail, className }: TimestampProps) {
  if (!modified && !published) return null

  const formattedModifiedDate = modified ? formatUpdatedDate(modified) : undefined
  const formattedPublishedDate = published ? formatUpdatedDate(published) : undefined
  const triggerDate = formattedModifiedDate ?? formattedPublishedDate

  const TimestampOverview = (
    <div className="flex w-fit flex-col gap-1 rounded-lg bg-zinc-950 p-3">
      {modified && <TimestampRow date={formattedModifiedDate} lead="Last updated: " />}
      {published && <TimestampRow date={formattedPublishedDate} lead="First published: " />}
    </div>
  )

  return (
    <Overview content={TimestampOverview} className={cn('cursor-default px-3', className)}>
      <div data-review="ignore" className="meticulous-ignore">
        <TimestampRow date={triggerDate} lead={lead} trail={trail} />
      </div>
    </Overview>
  )
}

export function TimestampRow({ date, lead, trail }: TimestampRowProps) {
  return (
    <div
      data-review="ignore"
      className="meticulous-ignore flex items-center gap-3 truncate text-13 text-gray-500 dark:text-white/50"
    >
      <Icon name="circle-half-dotted-clock" />
      <span>
        {lead ? `${lead} ` : ''} {date} {trail ? ` ${trail}` : ''}
      </span>
    </div>
  )
}
